module.exports = __webpack_public_path__ + "static/media/penn_logo.bc861e0f.png";